if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  require('promise/lib/rejection-tracking').enable()
  window['Promise'] = require('promise/lib/es6-extensions.js')
}

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require('object-assign')

// For supporting IE 9~11
require('core-js/shim')
require('event-source-polyfill')
require('raf/polyfill')
require('./polyfills/setPrototypeOf')
require('./polyfills/intersection-observer')
require('web-animations-js')
